module.exports = __webpack_public_path__ + "static/vegas13-4-1df116af1824ad866bcf6117560d2776.jpg";